import React, { useMemo, useState, useRef, useEffect, useContext } from "react";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { dateConvert, dateHoverRange } from "../../../utils/Helper";
import { callautopopulate } from "../../../services/callautopop";
import _ from "underscore";
import { DateObject } from "react-multi-date-picker";
import { ToastContext } from "../../../context/ToastContext";
import { useCommon } from "../../Common/useCommon";

export const useExtendRequestList = () => {
    const { getValuePermission } = useCommon();
    const { showSuccess, showError, showInfo } = useContext(ToastContext)
    const [rowData, setRowData] = useState([]);
    const [loader, setLoader] = useState({ main: false });
    const tagRef = useRef();
    const [filterValues, setFilterValues] = useState({ hoveredRange: [null, null] });
    const [dropDownOption, setDropDownOption] = useState({});
    const [showPopup, setShowPopup] = useState(false);
    const [pendingAction, setPendingAction] = useState(null);
    const [radioSelection, setRadioSelection] = useState(null);
    const [selectedRow, setSelectedRow] = useState([]);

    useEffect(() => {
        callautopopulate("all_users", "request_status", "user_info").then((res) => {
            setDropDownOption({
                statusOptions: res?.request_status,
                users: _.sortBy(res?.all_users, "user_display_name"),
                userData: res?.user_info?.[0],
                isGovernanceExcellence: res?.user_info?.[0]?.user_category_key === "governance-excellence"
            });
            setFilterValues(prev => ({ ...prev, status: res?.request_status?.[0] }));
        }).catch(console.error);
    }, []);

    const dynamicStatusOptions = dropDownOption?.statusOptions?.filter(o =>
        ["is_pending", "is_approved", "is_rejected", "is_grant"].includes(o?.request_status_key)
    );
    const columns = [
        {
            key: "selection",
            label: "",
            checkbox: true,
            style: { width: "5%" },
            headerStyle: { textAlign: "center" },
            hide: filterValues?.status?.request_status_key === "is_grant",
            sort: false,
            render: (row, isAll) => {
                const status = filterValues?.status?.request_status_key;
                const isGov = dropDownOption?.isGovernanceExcellence;
                const userCode = dropDownOption?.userData?.user_code;
                const allowedStatus = ["is_pending", "is_rejected", "is_approved"];
                const govStatus = ["is_rejected", "is_approved"];
                const isActionable = (r) => (userCode === r?.approver1_user_code && allowedStatus.includes(status)) || (isGov && govStatus.includes(status));
                const actionableRows = (rowData || []).filter(isActionable);
                if (!isAll && !isActionable(row)) return null;
                const isChecked = isAll
                    ? actionableRows.length > 0 &&
                    (selectedRow?.length || 0) === actionableRows.length
                    : (selectedRow || []).some(
                        (i) => i.enable_request_id === row?.enable_request_id
                    );
                return (
                    <div className="d-flex justify-content-center w100">
                        <input
                            type="checkbox"
                            checked={isChecked}
                            className="input-dd"
                            onChange={() => handleChange(row, isAll, actionableRows)}
                        />
                    </div>
                );
            },
        },
        {
            key: "action",
            label: "Action",
            style: { textAlign: "center", width: "15%" },
            headerStyle: { textAlign: "center" },
            hide: filterValues?.status?.request_status_key === "is_grant" || getValuePermission("extend_action_request_btn") || filterValues?.status?.request_status_key === "is_pending" && dropDownOption?.isGovernanceExcellence,
            render: (row) => {
                const { enable_request_id, approver1_user_code } = row || {};
                const isCurrentUserApprover = dropDownOption?.userData?.user_code === approver1_user_code;
                const currentStatus = filterValues?.status?.request_status_key;
                const showApprove =
                    (currentStatus === "is_pending" && isCurrentUserApprover) ||
                    (currentStatus === "is_rejected" && (isCurrentUserApprover || dropDownOption?.isGovernanceExcellence)) ||
                    (currentStatus === "is_approved" && dropDownOption?.isGovernanceExcellence);

                const showReject =
                    (currentStatus === "is_pending" && isCurrentUserApprover) ||
                    (currentStatus === "is_approved" && (isCurrentUserApprover || dropDownOption?.isGovernanceExcellence));

                return (
                    <div className="d-flex gap-2 align-items-baseline justify-content-center">
                        {showApprove && <div className="cursor-pointer d-flex align-items-center p-1">
                            <input
                                type="radio"
                                name={`action-${enable_request_id}`}
                                value={"is_approved"}
                                className="sk-radio me-1"
                                checked={radioSelection?.id === enable_request_id && radioSelection?.status === "is_approved"}
                                onChange={(e) => handleRequest(e.target.value, [row])}
                            />
                            <span className="fw-semibold small">Approve</span>
                        </div>}
                        {showReject && <div className="cursor-pointer d-flex align-items-center p-1"> <input
                            type="radio"
                            name={`action-${enable_request_id}`}
                            value={"is_rejected"}
                            className="sk-radio me-1"
                            checked={radioSelection?.id === enable_request_id && radioSelection?.status === "is_rejected"}
                            onChange={(e) => handleRequest(e.target.value, [row])}
                        />
                            <span className="fw-semibold small">Reject</span>
                        </div>}
                    </div>
                );
            }
        },
        {
            key: "request_user_name",
            label: "Employee Name",
            style: { width: "12%" },
            render: (row) => <div>{row?.request_user_name}</div>,
        },
        {
            key: "apply_enable_datetime",
            label: "Extend Date",
            style: { textAlign: "center", width: "10%" },
            headerStyle: { textAlign: "center" },
            render: (row) => <div>{row?.apply_enable_datetime ? dateConvert(row?.apply_enable_datetime, "day-mon-year") : "-"}</div>,
        },
        {
            key: "user_display_name",
            label: filterValues?.status?.request_status_key === "is_rejected" ? "Rejected By" : filterValues?.status?.request_status_key === "is_pending" ? "Approver" : "Approved by",
            style: { width: "12%" },
            render: (row) => (
                <div>
                    {row?.user_display_name || "—"}
                </div>
            ),
        },
        {
            key: "approve1_datetime",
            label: filterValues?.status?.request_status_key === "is_rejected" ? "Rejected Datetime 1" :
                "Approved 1 Datetime",
            hide: filterValues?.status?.request_status_key === "is_pending",
            style: { textAlign: "center", width: "15%" },
            headerStyle: { textAlign: "center" },
            render: (row) => (
                <div>
                    {row?.approve1_datetime ? dateConvert(row?.approve1_datetime, "date-time-months") : "-"}
                </div>
            ),
        },
        {
            key: "approve2_datetime",
            label: filterValues?.status?.request_status_key === "is_rejected" ? "Rejected Datetime 2" :
                "Approved 2 Datetime",
            hide: ["is_pending"].includes(filterValues?.status?.request_status_key),
            style: { textAlign: "center", width: "15%" },
            headerStyle: { textAlign: "center" },
            render: (row) => (
                <div>
                    {row?.approve2_datetime ? dateConvert(row?.approve2_datetime, "date-time-months") : "-"}
                </div>
            ),
        },
        {
            key: "reason",
            label: "Reason",
            style: { textAlign: "left", width: "15%", flex: 1 },
            render: (row) => <div title={row?.reason}>{row?.reason || "-"}</div>,
        }
    ];

    const handleChange = (row, isAll, actionableRows) => {
        if (isAll) {
            const isAllSelected = actionableRows.length > 0 && selectedRow?.length === actionableRows.length;
            setSelectedRow(isAllSelected ? [] : [...actionableRows]);
        } else {
            setSelectedRow(prev => {
                const isSelected = _.some(prev, (item) => _.isEqual(item, row));
                if (isSelected) {
                    return _.filter(prev, (item) => !_.isEqual(item, row));
                } else {
                    return [...prev, row];
                }
            });
        }
    };


    const handleStatusChange = (e, key) => {
        const data = _.findWhere(dropDownOption?.statusOptions, {
            request_status_id: parseInt(e.target.value)
        });
        if (key === "is_grant") {
            const now = new Date();
            const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
            const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
            setFilterValues((prev) => ({ ...prev, status: data, hoveredRange: [new DateObject(firstDay), new DateObject(lastDay)], apiCall: true }))
        } else {
            setFilterValues(prev => ({ ...prev, status: data, hoveredRange: [0, 0], apiCall: true }));
        }

    };

    useEffect(() => {
        if (filterValues?.status && filterValues.apiCall) {
            getTimesheetlist();
        }
    }, [filterValues.status, filterValues.apiCall]);

    const getTimesheetlist = async () => {
        try {
            setLoader(true);
            const payload = {
                request_status_id: filterValues?.status?.request_status_id || 0,
                from_date: filterValues?.hoveredRange?.[0] ? dateHoverRange(filterValues?.hoveredRange?.[0]) : "",
                to_date: filterValues?.hoveredRange?.[1] ? dateHoverRange(filterValues?.hoveredRange?.[1]) : "",
                users: _.pluck(filterValues?.all_users, "user_code")?.toString() || "",
            };
            const res = await services.getInvokeRemote("POST", Urls("GETENABLEDATEREQUEST"), payload);
            if (res?.body?.data) {
                setRowData(res?.body?.data);
            } else {
                setRowData([]);
                setFilterValues((prev) => ({ ...prev, apiCall: false }))
            }
        } catch (error) {
            console.error("API Error:", error);
            setRowData([]);
        } finally {
            setFilterValues((prev) => ({ ...prev, apiCall: false }))
            setLoader(false);
        }
    };


    const handleRequest = (status, rowData, isBulk) => {
        if (selectedRow?.length <= 0 && status === "is_approved" && isBulk) {
            showInfo("Info", "Please select a request to approve.");
            return
        } else if (selectedRow?.length <= 0 && status === "is_rejected" && isBulk) {
            showInfo("Info", "Please select a request to reject.");
            return
        }
        if (!isBulk) {
            setRadioSelection(prev => ({ ...prev, id: rowData[0]?.enable_request_id, status }));
        }
        setPendingAction(prev => ({ ...prev, status, rowData }));

        setShowPopup(true);
    };


    const confirmAction = async () => {
        if (!pendingAction) return;
        try {
            const { status, rowData } = pendingAction;
            const currentUserCode = dropDownOption?.userCode || dropDownOption?.userData?.user_code || 0;
            let finalStatus = status;
            if (dropDownOption?.isGovernanceExcellence) {
                finalStatus = status === "is_approved" ? "is_grant" : status;
            }

            const requestStatus = _.findWhere(dropDownOption?.statusOptions, {
                request_status_key: finalStatus
            });
            const currentDateTime = dateConvert(new Date(), 'iso-string');
            const payload = {
                enable_date_request: rowData.map((rowData) => ({
                    enable_request_id: rowData?.enable_request_id,
                    reason: rowData?.reason || '',
                    apply_enable_datetime: rowData?.apply_enable_datetime ? dateConvert(rowData?.apply_enable_datetime, 'iso-string') : "",
                    approve1_datetime: rowData?.approve1_datetime ? dateConvert(rowData?.approve1_datetime, 'iso-string') : currentDateTime,
                    approver2_user_code: dropDownOption?.isGovernanceExcellence ? currentUserCode : (rowData?.approver2_user_code || 0),
                    approve2_datetime: dropDownOption?.isGovernanceExcellence ? currentDateTime : (rowData?.approve2_datetime || ""),
                    request_status_id: requestStatus?.request_status_id,
                    approver1_user_code: rowData?.approver1_user_code || 0,
                }))
            };
            const res = await services.getInvokeRemote("POST", Urls("UPSERTENABLEDATEREQUEST"), payload);
            if (res?.body?.data) {
                showSuccess('Success', `Request ${finalStatus.replace('is_', '')}`);
                getTimesheetlist();
                setSelectedRow([])
            }
        } catch (error) {
            showError("Error", error?.response?.data?.errorMessage);
        } finally {
            setShowPopup(false);
            setPendingAction(null);
            setRadioSelection(null);
        }
    };

    return useMemo(() => ({
        columns, rowData, tagRef, loader, filterValues, setFilterValues, selectedRow, showInfo, handleRequest,
        getTimesheetlist, dropDownOption, handleStatusChange, dynamicStatusOptions, showPopup, setShowPopup, pendingAction, confirmAction, setRadioSelection
    }), [columns, rowData, tagRef, loader, filterValues, setFilterValues, selectedRow, showInfo, handleRequest,
        getTimesheetlist, dropDownOption, handleStatusChange, dynamicStatusOptions, showPopup, setShowPopup, pendingAction, confirmAction, setRadioSelection]);
};



